// extracted by mini-css-extract-plugin
module.exports = {"root":"DropLink_root__OBqSL","contents":"DropLink_contents__tPTIG","icon":"DropLink_icon__blJKF","iconNarrowBreakpoints":"DropLink_iconNarrowBreakpoints__804KY"};